'use client'

import { Divider } from '@mui/material'
import { FilledInfoIcon } from '@repo/ui/FilledInfoIcon'
import { useEffect } from 'react'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardFormSection } from '@repo/ui/WizardFormSection'
import { WizardIconTitle } from '@repo/ui/WizardIconTitle'
import { WizardPanel } from '@repo/ui/WizardPanel'
import { useNotificationStore } from '@repo/store/useNotificationStore'
import { v4 as uuidv4 } from 'uuid'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'
import PropTypes from 'prop-types'

export const NewMatterNotificationApprovalIntroduction = ({ wideMode, handlePrevNext, updateStepState }) => {
  const { fetchNewMatterNotification, newNotification } = useNotificationStore()

  useEffect(() => {
    const getNotificationDeatils = async () => {
      await fetchNewMatterNotification()
    }

    getNotificationDeatils()
  }, [fetchNewMatterNotification])

  const handleContinueButtonClick = () => {
    updateStepState({ status: 'completed', statusText: 'Complete' })
    handlePrevNext(1)
  }

  return (
    <>
      <WizardPanel data-testid="NewMatterNotificationApprovalIntroduction">
        <WizardFormSection>
          <WizardIconTitle
            title="Introduction"
            icon={FilledInfoIcon}
            sx={{
              alignItems: 'flex-start',
              justifyContent: 'flex-end',
              [`& .MuiStack-root`]: {
                alignItems: 'center'
              }
            }}
          />
          <MUITypography variant="body1">
            Perfect Portal have informed us of a new record with the following details. Click &apos;Continue&apos; to
            approve.
          </MUITypography>

          <MUIStack gap={4} direction="column" alignItems="flex-start" sx={{ m: 6, width: '100%' }}>
            <MUIStack gap={4} direction="column" alignItems="flex-start" sx={{ width: '100%' }}>
              <MUIStack gap={4} direction="column" alignItems="flex-start" sx={{ width: '100%' }}>
                <MUITypography variant="h6" sx={{ m: 0 }}>
                  Matter Details
                </MUITypography>
              </MUIStack>
              <Divider sx={{ width: '100%' }} />
              <MUIStack gap={4} direction="column" alignItems="flex-start" sx={{ width: '100%' }}>
                <MUITypography variant="body1" sx={{ textTransform: 'uppercase', m: 0, mb: -2, fontWeight: '600' }}>
                  Matter Description
                </MUITypography>
                <MUITypography variant="body1" sx={{ mb: 8 }}>
                  {newNotification && newNotification.matter.description}
                </MUITypography>
              </MUIStack>
            </MUIStack>

            <MUIStack gap={4} direction="column" alignItems="flex-start" sx={{ width: '100%' }}>
              <MUIStack gap={4} direction="column" alignItems="flex-start" sx={{ width: '100%' }}>
                <MUITypography variant="h6" sx={{ m: 0 }}>
                  Client Details
                </MUITypography>
              </MUIStack>
              <Divider sx={{ width: '100%' }} />
              <MUIStack gap={4} direction="row" alignItems="flex-start" sx={{ width: '100%' }}>
                {newNotification &&
                  newNotification.clients[0].namedClients.map((client) => (
                    <MUIStack
                      gap={4}
                      direction="column"
                      alignItems="flex-start"
                      sx={{ width: '100%' }}
                      key={`${client.forename}-${client.surname}-${uuidv4()}`}
                    >
                      <MUITypography variant="h6" sx={{ textTransform: 'uppercase', mt: 4, mb: -4 }}>
                        {client.title ?? ''} {client.forename} {client.surname}
                      </MUITypography>
                      <MUITypography variant="body1">{client.emailAddress ?? ''}</MUITypography>
                      <MUITypography variant="body1" sx={{ mt: 2, mb: 2 }}>
                        {client.area ? `${client.house ? client.house + ' ' : ''}${client.area}` : ''}
                        <br />
                        {client.postalTown ? `${client.postalTown}` : ''}
                        <br />
                        {client.county ? `${client.county}` : ''}
                        <br />
                        {client.postcode ? `${client.postcode}` : ''}
                      </MUITypography>
                    </MUIStack>
                  ))}
              </MUIStack>

              <MUITypography variant="body1" sx={{ textTransform: 'upperCase', mt: 2, fontWeight: '600' }}>
                Phone numbers
              </MUITypography>
              <MUIStack gap={4} direction="row" alignItems="flex-start" sx={{ width: '100%' }}>
                {newNotification &&
                  newNotification.clients[0].clientPhones.map((client) => (
                    <div style={{ width: '100%' }} key={`${client.description}-${uuidv4()}`}>
                      <MUITypography variant="body1" sx={{ mb: 0 }}>
                        {client.phoneNumber ?? ''}
                      </MUITypography>
                      <MUITypography variant="body1" sx={{ textTransform: 'capitalize' }}>
                        {client.description ?? ''}
                      </MUITypography>
                    </div>
                  ))}
              </MUIStack>
            </MUIStack>
          </MUIStack>
        </WizardFormSection>
      </WizardPanel>
      <WizardFooter
        wideMode={wideMode}
        continueButtonText="Continue"
        backButtonVisible={false}
        handleClickContinue={handleContinueButtonClick}
      />
    </>
  )
}

NewMatterNotificationApprovalIntroduction.propTypes = {
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func,
  updateStepState: PropTypes.func
}
